import React from "react";
import ReactDOM from "react-dom";
import CustomEvent from "custom-event";
import { SuburbModel } from "../models/SuburbModel";
import ReactSelectWrap from "../components/ReactSelectWrap";
import each from "lodash/each";
import uniq from "lodash/uniq";
import flatten from "lodash/flatten";
import orderBy from "lodash/orderBy";
import * as Request from "superagent";
import { ApiBasePath } from "../utils/ApiBasePath";
import { CalendarMonthsAbbrev } from "../models/CalendarMonths";
import ParseQueryString from "../utils/ParseQueryString";
import PostcodeInline from "../components/Postcode/PostcodeInline";

class Offers {
  isLocationRestored: boolean = false;
  isOfferListingPage: boolean = false;
  isOffersLandingPage: boolean = false;
  isOfferEnquirePage: boolean = false;
  categoryFilter: string = null;
  suburb: SuburbModel = null;

  constructor() {
    this.isOfferListingPage = !!document.querySelector(".offerListing");
    this.isOffersLandingPage = !!document.querySelector(".offersLanding");
    this.isOfferEnquirePage = !!document.querySelector(".offerEnquire");

    if (
      !this.isOfferListingPage &&
      !this.isOffersLandingPage &&
      !this.isOfferEnquirePage
    ) {
      return;
    }

    const inlinePostcode = document.querySelector(".inlinePostcodeLookup");
    // const inlinePostcode = document.querySelector(".text-center.h1");
    // const hiddenField = document.createElement("input");
    // const formEl = document.createElement("form");
    if (inlinePostcode) {
      const hiddenField = document.getElementById(
        "enquiryPostCode"
      ) as HTMLInputElement;
      const formEl = document.querySelector("form.contour") as HTMLFormElement;

      if (hiddenField && formEl) {
        ReactDOM.render(
          <PostcodeInline
            emitEvents={false}
            fieldEl={hiddenField}
            formEl={formEl}
          />,
          inlinePostcode
        );
      }
    }

    if (this.isOffersLandingPage) {
      this.handleCategoryChange();
      this.restoreCategoryFromQueryString();
    }

    each(
      document.querySelectorAll(
        ".offersHeader__locationEdit, .offersHeader__locationSet"
      ),
      (el) =>
        el.addEventListener("click", (e) => {
          e.preventDefault();
          this.selectLocation();
        })
    );

    window.addEventListener("locationSelected", (e: any) =>
      this.locationSelected(e)
    );

    window.addEventListener("load", () => {
      const offerEl = document.querySelector(".offerListing, .offerEnquire");
      if (offerEl) {
        const isNational = offerEl.getAttribute("data-offerIsNational");
        if (isNational && isNational.toLowerCase() === "true") {
          document.body.classList.remove(
            "offerAvailable",
            "offerExpired",
            "offerGeoBlocked",
            "offerNotStarted"
          );
          document.body.classList.add("offerAvailable");
          return;
        }
      }
      if (!this.isLocationRestored) this.selectLocation();
    });

    if (this.isOfferEnquirePage || this.isOfferListingPage) {
      window.addEventListener("locationSelectCancelled", () => {
        const offerEl = document.querySelector(".offerListing, .offerEnquire");
        if (offerEl) {
          const isNational = offerEl.getAttribute("data-offerIsNational");
          if (isNational && isNational.toLowerCase() === "false") {
            this.updateVisibility();
          }
        }
      });
    }
  }

  restoreCategoryFromQueryString() {
    const query = ParseQueryString();
    if (query["category"] === "undefined") {
      return false;
    }

    const cats = document.querySelectorAll(
      ".offersHeader__categoriesWrap .dd__item"
    );
    if (!cats) return;

    window.onload = () => {
      each(cats, (cat) => {
        if (
          cat.innerHTML.toLowerCase() ===
          decodeURI(query["category"]).toLowerCase()
        ) {
          cat.click();
        }
      });
    };
  }

  selectLocation(): void {
    const evt = new CustomEvent("selectLocation", { detail: {} });
    window.dispatchEvent(evt);
  }

  locationSelected(e: any): void {
    this.suburb = e.detail.suburb;

    if (e.detail.isRestored) {
      this.isLocationRestored = true;
    }

    this.updateLocationLabel(e.detail.suburb);
    each(document.querySelectorAll(".offersHeader"), (group) =>
      group.classList.add("offersHeader--hasLocation")
    );

    if (this.isOffersLandingPage && !e.detail.isRestored) {
      this.getOffersByPostcode(e.detail.suburb.postcode);
    }

    if (this.isOfferListingPage || this.isOfferEnquirePage) {
      this.updateVisibility(e.detail.suburb);
    }
  }

  getOffersByPostcode(postcode: string) {
    Request.get(`${ApiBasePath.offers}/${postcode}`).end((err, res) => {
      if (res.notFound) {
        this.displayOffers([]);
      } else {
        this.categoryFilter = "All Categories";

        const offers = JSON.parse(res.text);
        this.displayOffers(offers);

        const offerCategories = flatten(
          offers.map((offer) => offer.categories)
        );
        const uniqueCategories = uniq(offerCategories).map((item, index) => ({
          id: index + 1,
          name: item,
        }));
        const orderedCategories = orderBy(uniqueCategories, ["name"], ["asc"]);

        window["offerCategories"] = orderedCategories;
        this.handleCategoryChange();
      }
    });
  }

  buildOfferSummaryContent(content) {
    if (!content) {
      return "";
    }

    switch (content.type) {
      case "list":
        return (() => {
          let returnHtml = "";

          if (content.attributes.length) {
            returnHtml += `<p>${content.attributes[0].value}</p>`;
          }

          returnHtml += '<ul class="offersList">';
          content.children.map((item) => {
            returnHtml += `<li class="offersList__item">${item.attributes[0].value}</li>`;
          });
          returnHtml += "</ul>";
          return returnHtml;
        })();
      case "paragraph":
        return `<p>${content.attributes[0].value}</p>`;

      default:
        break;
    }

    return "";
  }

  buildOfferSummaryCTA(offer) {
    if (offer.price) {
      return `<div class="offerSummary__cta">
                <div class="offerSummary__btn offerSummary__btn--twoTone">
                  <div class="offerSummary__btnContent">
                    <div class="offerSummary__btnPriceWrap">
                      <div class="offerSummary__btnPriceLabel">${
                        offer.callToActionText !== undefined &&
                        offer.callToActionText !== ""
                          ? offer.callToActionText.toUpperCase()
                          : "VIEW OFFER"
                      }</div>
                      <div class="offerSummary__btnPrice">
                        <sup>$</sup>${offer.price}<sup>*</sup>
                      </div>
                    </div>
                    <div class="offerSummary__btnText">VIEW OFFER</div>
                  </div>
                </div>
                <div class="offerSummary__tc">*Terms &amp; Conditions apply</div>
              </div>`;
    } else {
      return `<div class="offerSummary__cta">
                <div class="offerSummary__btn">
                  <div class="offerSummary__btnContent">
                    <div class="offerSummary__btnText">${
                      offer.callToActionText !== undefined &&
                      offer.callToActionText !== ""
                        ? offer.callToActionText.toUpperCase()
                        : "VIEW OFFER"
                    }</div>
                  </div>
                </div>
              </div>`;
    }
  }

  buildOfferSummary(offer) {
    const date = offer.expiryDate ? new Date(offer.expiryDate + "Z") : null;
    const dateStr = date
      ? `${date.getDate()} ${
          CalendarMonthsAbbrev[date.getMonth()]
        } ${date.getFullYear()}`
      : "";

    const expirySash =
      date && offer.sashStyle
        ? `<div class="offerSummary__expiry" style="${offer.sashStyle}">
        Offer ends<br>${dateStr}
    </div>`
        : "";

    let offerSummaryHtml = `<article class="offerSummary" data-offerid="${
      offer.id
    }" data-offercategory="${offer.categories.join()}">
        <a class="offerSummary__link" href="/special-offers/${
          offer.uniqueName
        }">
          <div class="offerSummary__imageWrap">
            <img class="offerSummary__image" src="${
              offer.featuredMedia ? offer.featuredMedia.url : ""
            }" alt="" loading="lazy">
          </div>

          <div class="offerSummary__content">
            <div class="offerSummary__copy">
              <h2 class="offerSummary__title">${offer.name}</h2>
              ${this.buildOfferSummaryContent(offer.featuredContent)}
            </div>

            ${this.buildOfferSummaryCTA(offer)}
          </div>
            ${expirySash}
        </a>
    </article>`;

    return offerSummaryHtml;
  }

  displayOffers(offers) {
    let offerHtml = "";

    offers.map((offer) => {
      if (!offer.isHiddenFromListing) {
        offerHtml += this.buildOfferSummary(offer);
      }
    });

    const wrap = document.getElementById("offerSummaryItems");
    if (wrap) {
      if (offers.length) {
        wrap.innerHTML = offerHtml;
        this.applyCategoryFilter();
      } else {
        wrap.innerHTML =
          '<div class="offerSummary__noItems">No offers available</div>';
      }
    }
  }

  updateLocationLabel(suburb: SuburbModel): void {
    const labels = document.querySelectorAll(".offersHeader__location");
    each(
      labels,
      (label) =>
        (label.textContent =
          `${suburb.name}, ${suburb.postcode} ${suburb.state}`.toUpperCase())
    );
  }

  updateVisibility(suburb = this.suburb) {
    if (!suburb) {
      console.log("unavail");
      return setToUnavailable();
    }

    const offerPage = this.isOfferListingPage
      ? document.querySelector(".offerListing")
      : this.isOfferEnquirePage
      ? document.querySelector(".offerEnquire")
      : null;

    if (!offerPage) return;

    let offerStartDate;
    let offerExpiryDate;

    Request.get(
      `${ApiBasePath["offers"]}/${
        suburb.postcode
      }/offers/${offerPage.getAttribute("data-offerUniqueName")}`
    ).then(
      (res) => {
        const offer = res.body;
        const date = new Date();
        offerStartDate = new Date(offer.startDate + "Z");
        offerExpiryDate = new Date(offer.expiryDate + "Z");
        const isExpired = date > offerExpiryDate;
        const isUpcoming = date < offerStartDate;

        const postCode = document.getElementById(
          "enquiryPostCode"
        ) as HTMLInputElement;
        if (postCode) {
          postCode.value = suburb.postcode;
        }

        if (!isUpcoming && !isExpired) {
          setToAvailable();
        } else {
          const offerStatus = isExpired ? 1 : isUpcoming ? 2 : null;
          setToUnavailable(offerStatus);
        }
      },
      (err) => {
        setToUnavailable();
      }
    );

    function setToAvailable(): void {
      const contentWrap = document.querySelector(
        ".offerEnquire__available,.offerListing__available"
      );
      if (contentWrap) {
        const state = contentWrap.getAttribute("data-isAvailable") === "true";
        if (!state) {
          console.log("Offer available, reload.");
          document.location.reload();
        } else {
          console.log("Offer available, dont reload.");
          document.body.classList.remove(
            "offerAvailable",
            "offerExpired",
            "offerGeoBlocked",
            "offerNotStarted"
          );
          document.body.classList.add("offerAvailable");
        }
      }
    }

    function setToUnavailable(offerStatus?: number): void {
      const contentWrap = document.querySelector(
        ".offerEnquire__available,.offerListing__available"
      );
      contentWrap.setAttribute("data-isAvailable", "false");
      document.body.classList.remove(
        "offerAvailable",
        "offerExpired",
        "offerGeoBlocked",
        "offerNotStarted"
      );

      switch (offerStatus) {
        case 1: //offer is expired
          document.body.classList.add("offerExpired");
          break;
        case 2: //offer is not started
          document.body.classList.add("offerNotStarted");

          const startDateEl = document.querySelector(".offerStartDate");
          if (startDateEl) {
            const dateStr = `${offerStartDate.getDate()} ${
              CalendarMonthsAbbrev[offerStartDate.getMonth()]
            } ${offerStartDate.getFullYear()}`;
            startDateEl.innerHTML = dateStr;
          }

          break;
        default:
          document.body.classList.add("offerGeoBlocked");
          break;
      }

      window.scrollTo(0, 0);
    }
  }

  handleCategoryChange() {
    const select = document.querySelector(".dd__select");
    select.removeChild(select.children[0]);

    if (select && window["offerCategories"]) {
      let options = window["offerCategories"].map((item) => {
        return { value: item.id, label: item.name };
      });

      options.unshift({ value: "", label: "All Categories" });
      ReactDOM.render(
        <ReactSelectWrap
          options={options}
          reactSelectProps={{ clearable: false }}
          onChange={(e) => {
            this.categoryFilter = e.label;
            this.applyCategoryFilter();
          }}
        />,
        select
      );
    }
  }

  applyCategoryFilter() {
    const offers = document.querySelectorAll(".offerSummary");
    const className = "offerSummary--hidden";
    let amountOfOffers: number = 0;
    if (
      this.categoryFilter === "" ||
      this.categoryFilter === "All Categories"
    ) {
      each(offers, (offer) => {
        offer.classList.remove(className);
      });
      amountOfOffers = offers.length;
    } else {
      each(offers, (offer) => {
        const cat = offer.getAttribute("data-offercategory");
        let inCategory = false;

        if (cat && this.categoryFilter) {
          inCategory =
            cat
              .toLowerCase()
              .split(",")
              .indexOf(this.categoryFilter.toLowerCase()) !== -1;
        }

        if (!this.categoryFilter) {
          inCategory = true;
        }

        if (inCategory) {
          amountOfOffers++;
        }

        offer.classList.toggle(className, !inCategory);
      });
    }

    this.toggleNoOffersMessage(!amountOfOffers);
  }

  toggleNoOffersMessage(showMessage: boolean): void {
    const wrap = document.getElementById("offerSummaryItems");
    const messageEl = wrap.querySelector(".offerSummary__noItems");

    if (showMessage && !messageEl) {
      const noOffersEl = document.createElement("div");
      noOffersEl.classList.add("offerSummary__noItems");
      noOffersEl.textContent = "No offers available";

      wrap.appendChild(noOffersEl);
    }

    if (!showMessage && messageEl) {
      wrap.removeChild(messageEl);
    }
  }
}

export default () => new Offers();
